/*
  Produktdatenblock je Variante
  -----------------------------
  Hängt sich wie cross-cell-variant.js an das Event "variantChange"
  von product-info.js und tauscht den Block
  #ProductInformation-<section.id> gegen die frisch gerenderte Fassung.
*/
(function () {
  if (window.productInformationVariantReady) return;
  window.productInformationVariantReady = true;

  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const sectionId = event?.data?.sectionId;
    const html = event?.data?.html;
    if (!sectionId || !html) return;

    const source = html.getElementById(`ProductInformation-${sectionId}`);
    if (!source) return;

    document.querySelectorAll('product-info').forEach((productInfo) => {
      const infoSectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
      if (infoSectionId !== sectionId) return;

      const destination = productInfo.querySelector('[id^="ProductInformation-"]');
      if (!destination) return;

      destination.innerHTML = source.innerHTML;
    });
  });
})();